import { Tooltip } from '@mui/material';
import { withStyles } from '@mui/styles';
import React from 'react';

const CustomMoreActionTooltip = withStyles({
   tooltip: {
      '&.MuiTooltip-tooltip': {
         padding: 0,
         borderRadius: '6px',
         fontFamily: "'Montserrat', san-serif",
      },
   },
})(Tooltip);

const EventImageTooltip = ({ value, children }) => {
   return (
      <div className='w-full overflow-hidden'>
         <CustomMoreActionTooltip
            title={
               value && (
                  <div className='p-3'>
                     <p className='text-sm'>{value}</p>
                  </div>
               )
            }
            placement='top'
            arrow
         >
            <div>{children}</div>
         </CustomMoreActionTooltip>
      </div>
   );
};

export default EventImageTooltip;
